import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    solicitudesDev: [],
}

const GET_SOLICITUDES_DEV = 'GET_SOLICITUDES_DEV'
//MÉTODOS 

export const IniciarProceso = createAsyncThunk(
    GET_SOLICITUDES_DEV,
    async (files) => {
        try {
            const fullUrl = host + `ConstanciasDev/ObtenerInformacionConstancias`
            const fullUrlConstancias = host + `ConstanciasDev/GenerarConstanciaDev`
            const kmlUrl = host + `PoligonoKml/agregarPoligonoKml`
            console.log(' inciando proceso')

            const res = await axios.get(fullUrl)
            console.log(' la res ', res.data.data)
            for (let i = 3580; i >= 0; i--) {
                console.log(i)
                let resultadoConstancia = res?.data?.data?.[i]
                console.log('numero ', resultadoConstancia)
                let busquedaFileKML = files.filter(anexo => anexo.name.split('.')[0]== resultadoConstancia?.cliente?.numerosocio)
                console.log('busquedaFileKML ', busquedaFileKML)
                let tipoguia = 'NORMAL'
                if (busquedaFileKML?.length > 0) {

                let domicilioFiscal = []
                if (resultadoConstancia?.cliente?.domiciliofiscalcliente?.length == 1) domicilioFiscal = resultadoConstancia?.cliente?.domiciliofiscalcliente
                else domicilioFiscal = resultadoConstancia?.cliente?.domiciliofiscalcliente?.filter(anexo => anexo?.domicilioprincipal == true)

                let numeroexterior = ''
                let numerointerior = ''
                let colonia = ''

                if (domicilioFiscal?.[0]?.numeroexterior === null || domicilioFiscal?.[0]?.numeroexterior === '' ||
                    domicilioFiscal?.[0]?.numeroexterior === ' ') numeroexterior = 's/n'
                else numeroexterior = domicilioFiscal?.[0]?.numeroexterior

                if (domicilioFiscal?.[0]?.numerointerior === null || domicilioFiscal?.[0]?.numerointerior === '' ||
                    domicilioFiscal?.[0]?.numerointerior === ' ') numerointerior = 's/n'
                else numerointerior = domicilioFiscal?.[0]?.numerointerior

                if (domicilioFiscal?.[0]?.colonia === null || domicilioFiscal?.[0]?.colonia === '' ||
                    domicilioFiscal?.[0]?.colonia === ' ') colonia = 'sin colonia'
                else colonia = domicilioFiscal?.[0]?.colonia

                let domicilio = domicilioFiscal?.[0]?.calle + ', ' + numerointerior + ', ' + numeroexterior + ', ' + colonia + ',' +
                    domicilioFiscal?.[0]?.localidad + ', ' + domicilioFiscal?.[0]?.municipioalcaldia + ', ' + domicilioFiscal?.[0]?.estado + ', ' +
                    domicilioFiscal?.[0]?.codigopostal

                let datosMaguey = []
                for (const j in resultadoConstancia?.datosmaguey) {
                    datosMaguey.push({
                        especieCientifico: resultadoConstancia?.datosmaguey?.[0]?.catalogomaguey?.catalogomagueynombrecientifico?.nombrecientifico,
                        especie: resultadoConstancia?.datosmaguey?.[j]?.especie,
                        numeroplantas: resultadoConstancia?.datosmaguey?.[j]?.numeroplantas,
                        sistemaplantacion: resultadoConstancia?.datosmaguey?.[j]?.sistemaplantacion,
                        edad: resultadoConstancia?.datosmaguey?.[j]?.edad,
                    })
                }

                    let formData = new FormData()
                    formData.append('archivo', busquedaFileKML?.[0])
                    formData.append('iddatospredio', resultadoConstancia?.iddatospredio)
                    const resultado = await axios.post(kmlUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    let constancia = {
                        datosmaguey: datosMaguey,
                        tipoguia:tipoguia,
                        idcliente: resultadoConstancia?.cliente?.idcliente,
                        iddatospredio: resultadoConstancia?.iddatospredio,
                        longitudoeste: resultadoConstancia.longitudoeste,
                        latitudnorte: resultadoConstancia.latitudnorte,
                        numerosocio: resultadoConstancia?.cliente?.numerosocio,
                        personafisica: resultadoConstancia?.cliente?.personafisica,
                        personamoral: resultadoConstancia?.cliente?.personamoral,
                        nombrerazonsocial: resultadoConstancia?.cliente?.nombrerazonsocial,
                        //fechasolicitud: infoCliente.fechasolicitud,//falta definir que fehca llevaria
                        rfc: resultadoConstancia?.cliente?.rfc,
                        telefono: resultadoConstancia?.cliente?.telefono,
                        correoelectronico: resultadoConstancia?.cliente?.correoelectronico,
                        nombrerepresentantelegal: resultadoConstancia?.cliente?.nombrerepresentantelegal,
                        telefonorepresentante: resultadoConstancia?.cliente?.telefonorepresentante,
                        correoelectronicorepresentante: resultadoConstancia?.cliente?.correoelectronicorepresentante,
                        empresacertificadora: resultadoConstancia?.cliente?.empresacertificadora,
                        idtipocliente: resultadoConstancia?.cliente?.tipocliente?.idtipocliente,
                        idlogin: resultadoConstancia?.cliente.idlogin,
                        superficiehectarea: resultadoConstancia?.superficiehectarea,
                        //idcartera: infoCliente.idcartera,//creo que este no va
                        nombrepredio: resultadoConstancia?.nombrepredio,
                        municipio: resultadoConstancia?.municipio,
                        localidad: resultadoConstancia?.localidad,
                        estado: resultadoConstancia?.estado,
                        domicilio: domicilio,
                        espropietario: resultadoConstancia?.espropietario,
                        nombrecompletopropietario: resultadoConstancia?.nombrecompletopropietario
                    };
                    const resConstancias = await axios.post(fullUrlConstancias, { data: constancia })
                }

            }


            return res.data.data
        } catch (error) {
            console.log(error.res);
            console.log(error);
        }
    }
)
export const IniciarProceso2 = createAsyncThunk(
    GET_SOLICITUDES_DEV,
    async (files) => {
        try {
            const fullUrl = host + `ConstanciasDev/ObtenerInformacionConstancias`
            const fullUrlConstancias = host + `ConstanciasDev/GenerarConstanciaDev`
            const kmlUrl = host + `PoligonoKml/agregarPoligonoKml`
            console.log(' inciando proceso ')

            const res = await axios.get(fullUrl)
            for (let i = 1475; i <= res.data.data.length; i++) {
                console.log('i ',i)
                let resultadoConstancia = res?.data?.data?.[i]
                console.log('numero ', resultadoConstancia)
                let busquedaFileKML = files.filter(anexo => anexo.name.split('.')[0]== resultadoConstancia?.cliente?.numerosocio)
                console.log('busquedaFileKML ', busquedaFileKML)
                let tipoguia = 'NORMAL'
                if (busquedaFileKML?.length > 0) {

                let domicilioFiscal = []
                if (resultadoConstancia?.cliente?.domiciliofiscalcliente?.length == 1) domicilioFiscal = resultadoConstancia?.cliente?.domiciliofiscalcliente
                else domicilioFiscal = resultadoConstancia?.cliente?.domiciliofiscalcliente?.filter(anexo => anexo?.domicilioprincipal == true)

                let numeroexterior = ''
                let numerointerior = ''
                let colonia = ''

                if (domicilioFiscal?.[0]?.numeroexterior === null || domicilioFiscal?.[0]?.numeroexterior === '' ||
                    domicilioFiscal?.[0]?.numeroexterior === ' ') numeroexterior = 's/n'
                else numeroexterior = domicilioFiscal?.[0]?.numeroexterior

                if (domicilioFiscal?.[0]?.numerointerior === null || domicilioFiscal?.[0]?.numerointerior === '' ||
                    domicilioFiscal?.[0]?.numerointerior === ' ') numerointerior = 's/n'
                else numerointerior = domicilioFiscal?.[0]?.numerointerior

                if (domicilioFiscal?.[0]?.colonia === null || domicilioFiscal?.[0]?.colonia === '' ||
                    domicilioFiscal?.[0]?.colonia === ' ') colonia = 'sin colonia'
                else colonia = domicilioFiscal?.[0]?.colonia

                let domicilio = domicilioFiscal?.[0]?.calle + ', ' + numerointerior + ', ' + numeroexterior + ', ' + colonia + ',' +
                    domicilioFiscal?.[0]?.localidad + ', ' + domicilioFiscal?.[0]?.municipioalcaldia + ', ' + domicilioFiscal?.[0]?.estado + ', ' +
                    domicilioFiscal?.[0]?.codigopostal

                let datosMaguey = []
                for (const j in resultadoConstancia?.datosmaguey) {
                    datosMaguey.push({
                        especieCientifico: resultadoConstancia?.datosmaguey?.[0]?.catalogomaguey?.catalogomagueynombrecientifico?.nombrecientifico,
                        especie: resultadoConstancia?.datosmaguey?.[j]?.especie,
                        numeroplantas: resultadoConstancia?.datosmaguey?.[j]?.numeroplantas,
                        sistemaplantacion: resultadoConstancia?.datosmaguey?.[j]?.sistemaplantacion,
                        edad: resultadoConstancia?.datosmaguey?.[j]?.edad,
                    })
                }

                    let formData = new FormData()
                    formData.append('archivo', busquedaFileKML?.[0])
                    formData.append('iddatospredio', resultadoConstancia?.iddatospredio)
                    const resultado = await axios.post(kmlUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    let constancia = {
                        datosmaguey: datosMaguey,
                        tipoguia:tipoguia,
                        idcliente: resultadoConstancia?.cliente?.idcliente,
                        iddatospredio: resultadoConstancia?.iddatospredio,
                        longitudoeste: resultadoConstancia.longitudoeste,
                        latitudnorte: resultadoConstancia.latitudnorte,
                        numerosocio: resultadoConstancia?.cliente?.numerosocio,
                        personafisica: resultadoConstancia?.cliente?.personafisica,
                        personamoral: resultadoConstancia?.cliente?.personamoral,
                        nombrerazonsocial: resultadoConstancia?.cliente?.nombrerazonsocial,
                        //fechasolicitud: infoCliente.fechasolicitud,//falta definir que fehca llevaria
                        rfc: resultadoConstancia?.cliente?.rfc,
                        telefono: resultadoConstancia?.cliente?.telefono,
                        correoelectronico: resultadoConstancia?.cliente?.correoelectronico,
                        nombrerepresentantelegal: resultadoConstancia?.cliente?.nombrerepresentantelegal,
                        telefonorepresentante: resultadoConstancia?.cliente?.telefonorepresentante,
                        correoelectronicorepresentante: resultadoConstancia?.cliente?.correoelectronicorepresentante,
                        empresacertificadora: resultadoConstancia?.cliente?.empresacertificadora,
                        idtipocliente: resultadoConstancia?.cliente?.tipocliente?.idtipocliente,
                        idlogin: resultadoConstancia?.cliente.idlogin,
                        superficiehectarea: resultadoConstancia?.superficiehectarea,
                        //idcartera: infoCliente.idcartera,//creo que este no va
                        nombrepredio: resultadoConstancia?.nombrepredio,
                        municipio: resultadoConstancia?.municipio,
                        localidad: resultadoConstancia?.localidad,
                        estado: resultadoConstancia?.estado,
                        domicilio: domicilio,
                        espropietario: resultadoConstancia?.espropietario,
                        nombrecompletopropietario: resultadoConstancia?.nombrecompletopropietario
                    };
                    const resConstancias = await axios.post(fullUrlConstancias, { data: constancia })
                }

            }


            return res.data.data
        } catch (error) {
            console.log(error.res);
            console.log(error);
        }
    }
)
export const ConstanciasDevSlice = createSlice({

    name: 'ConstanciasDevSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        /*[buscarSolicitudByFolio.fulfilled]: (state, { payload }) => {
            state.solicitudesDev = payload
        },*/
    },

})


export const { } = ConstanciasDevSlice.actions
export const ConstanciasDevReducer = ConstanciasDevSlice.reducer